<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header title="Região" subTitle="Adicionar" />

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom">
            <h6 class="m-0">Informações da Região</h6>
          </div>
          <region-form />
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import Events from '_utils/events';
import PageHeader from '_shared/PageHeader.vue';
import RegionForm from '../components/RegionForm.vue';

export default {
  name: 'admin-region-new',
  components: {
    PageHeader,
    RegionForm,
  },
  data() {
    return {};
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
  },
};
</script>
